import script from "./UserActionsMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./UserActionsMobile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__